import React from "react";
import styles from "./AboutNewsletter.module.scss";
import Circles from "./assets/circles.png";
import People from "./assets/manandwoman.png";

const { newsl, content, texts, people } = styles;
function AboutNewsletter() {
  return (
    <section className={`${newsl} global-lr-pad`}>
      <div className={content}>
        <div className={texts}>
          <img src={Circles} alt="Circles" />
          <h4>Stay up to date</h4>
          <p>Your’e probably thinking, “Another newsletter?”</p>
          <p>But we promise, youre going to love ours!</p>
          <form>
            <input type="text" placeholder="Your Email Address" />
            <button type="submit">Subscribe</button>
          </form>
        </div>
        <div className={people}>
          <img
            src={People}
            alt="Two users standing and using the we quick pay all"
          />
        </div>
      </div>
    </section>
  );
}

export default AboutNewsletter;
